var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container payment"},[(!_vm.isMobile)?_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-xs-12 col-sm-10 col-sm-offset-1 payment-view"},[_c('router-view')],1)]):_c('div',{staticClass:"wrapper"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }